/**
 * Converts a platform name to a normalized format from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 *
 * @param platformName - The platform name to convert.
 * @returns The normalized platform name, or undefined if the input is not recognized.
 */

export const platformNameConverter = (
  platformName: string | undefined
): 'ios' | 'android' | 'web' | undefined => {
  switch (platformName?.toLocaleLowerCase()) {
    case 'ios':
      return 'ios';
    case 'android':
      return 'android';
    case 'web app':
      return 'web';
    default:
      return undefined;
  }
};
